import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { useSiteManifest } from './site.js';
const ProjectContext = React.createContext(undefined);
export function ProjectProvider({ project, children, }) {
    var _a;
    const config = useSiteManifest();
    return (_jsx(ProjectContext.Provider, { value: project !== null && project !== void 0 ? project : (_a = config === null || config === void 0 ? void 0 : config.projects) === null || _a === void 0 ? void 0 : _a[0], children: children }));
}
export function useProjectManifest() {
    const config = useContext(ProjectContext);
    return config;
}
